import { render, staticRenderFns } from "./TreatmentGuide.vue?vue&type=template&id=0b4760a0&scoped=true"
import script from "./TreatmentGuide.vue?vue&type=script&lang=js"
export * from "./TreatmentGuide.vue?vue&type=script&lang=js"
import style0 from "./TreatmentGuide.vue?vue&type=style&index=0&id=0b4760a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4760a0",
  null
  
)

export default component.exports